import React, { useState } from 'react'
import axios from 'axios';
import useSWR from 'swr';

import { render } from 'react-dom';

import CenteredModal from './CenteredModal';

const LikesModal = (props) => {
  const { route, element } = props;

  const [show, setShow] = useState(false);
  const [pageIndex, setPageIndex] = useState(1);

  const getLikes = url => axios.get(url).then(res => res.data);

  const { data, error } = useSWR(`${route}?page=${pageIndex}`, getLikes);

  const onOpen = () => setShow(true);

  const onClose = () => setShow(false);

  if (!data) return null;

  const {
      data: items,
      prev_page_url,
      next_page_url,
  } = data;

  return (
    <>
      <CenteredModal
        show={show}
        onHide={onClose}
        onClick={onClose}
        title="Liked by"
      >
        {items &&
          <div>
            <ul className="col-auto mb-2 list-group list-group-flush">
              {items.map(item =>
                <li className="list-group-item bg-dark" key={item.id}>
                  <a href={`/user/${item.user.id}`}>{item.user.username}</a>
                  &nbsp;
                  liked {item.liked_at}
                </li>
              )}
            </ul>
            {(prev_page_url || next_page_url) &&
              <div className="d-flex justify-content-center">
                <nav aria-label="Page navigation example">
                  <ul className="pagination pagination-sm">
                    <li className={`page-item ${!prev_page_url && 'disabled'}`}>
                      <button className="page-link" onClick={() => setPageIndex(pageIndex - 1)} aria-label="Previous">
                        <span aria-hidden="true">&laquo;</span>
                        <span className="sr-only">Previous</span>
                      </button>
                    </li>
                    <li className="page-item disabled"><a className="page-link" href="#">{pageIndex}</a></li>
                    <li className={`page-item ${!next_page_url && 'disabled'}`}>
                      <button className="page-link" onClick={() => setPageIndex(pageIndex + 1)} aria-label="Next">
                        <span aria-hidden="true">&raquo;</span>
                        <span className="sr-only">Next</span>
                      </button>
                    </li>
                  </ul>
                </nav>
              </div>
            }
          </div>
        }
        {items.length === 0 && (
            <p className="text-center">Be the first to like this</p>
        )}
      </CenteredModal>
      <button className="btn btn-link p-0" onClick={onOpen} style={{ textDecoration: 'none' }}>
        <span className="h6 text-primary">
          <i className="fas fa-heart" />
        </span>
      </button>
    </>
  )
}

const node = document.getElementById('likes-modal');
const route = document.currentScript.getAttribute('data-route');
const rawElement = document.currentScript.getAttribute('data-element');
const element = rawElement ? JSON.parse(rawElement) : {};
node && render(<LikesModal route={route} element={element} />, node);
